import React from 'react';
import marked from 'marked';

export default class Markdown extends React.Component {
  render() {
    const markdown = this.props.children || this.props.content;
    return (
      markdown && (
        <div
          dangerouslySetInnerHTML={{
            __html: marked(markdown)
          }}
        />
      )
    );
  }
}
